// Intentional Pinia store — persists the connections list UI preferences (grid vs list view)
// to localStorage so the user's choice survives navigation and refresh. No API calls.
import { defineStore } from "pinia";

interface ConnectionPrefsState {
  viewMode: "grid" | "table";
}

export const useConnectionPrefsStore = defineStore({
  id: "connectionPrefs",
  persist: true,

  state: (): ConnectionPrefsState => ({
    viewMode: "grid",
  }),

  actions: {
    setViewMode(mode: "grid" | "table") {
      this.viewMode = mode;
    },
  },
});
